const getSuggestions = (suggestions = [], shipperOrderIds = []) => {
  const itineraryFound = suggestions.find((suggestion) =>
    shipperOrderIds.every((soId) => suggestion.shipper_order_ids.includes(soId))
  );

  if (!itineraryFound) {
    return null;
  }

  return {
    id: itineraryFound.id,
    upgrade_journey: itineraryFound.upgrade_journey,
  };
};

const matchSuggestions = ({ itineraries, suggestions }) => {
  return (itineraries || []).reduce((acc, itinerary) => {
    return {
      ...acc,
      [itinerary.id]: getSuggestions(suggestions, itinerary.shipper_order_ids),
    };
  }, {});
};

export { matchSuggestions };
